import { useMemo } from 'react';
import { WarehouseType } from '@elementary/common-ui/types';
import useCachedEnvironments from '@elementary/common-ui/hooks/useCachedEnvironments';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';

const TABLE_USAGE_SUPPORTED_WAREHOUSE_TYPES = new Set<WarehouseType>([
  'bigquery',
  'snowflake',
  'redshift',
  'databricks',
]);

const useIsTableUsageSupported = (): boolean => {
  const selectedEnvId = useSelectedEnv();
  const { data: environments } = useCachedEnvironments();

  return useMemo(() => {
    const warehouseType = environments?.find((env) => env.id === selectedEnvId)
      ?.dwhConnection.warehouseType;
    return warehouseType
      ? TABLE_USAGE_SUPPORTED_WAREHOUSE_TYPES.has(warehouseType)
      : false;
  }, [environments, selectedEnvId]);
};

export default useIsTableUsageSupported;
